import React from 'react'

const Gestion = () => {
  return (
    <div>Gestion</div>
  )
}

export default Gestion